module.exports = __webpack_public_path__ + "static/img/a1g.60a0cb25.webp";